var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { attrs: { align: "center" } },
    [
      _c(
        "v-flex",
        { attrs: { md10: "" } },
        [
          _c(
            "v-card",
            { staticClass: "rounded-card" },
            [
              _c(
                "v-form",
                {
                  ref: "form",
                  staticClass: "col-md-12",
                  attrs: { "lazy-validation": "" },
                  model: {
                    value: _vm.isFormValid,
                    callback: function($$v) {
                      _vm.isFormValid = $$v
                    },
                    expression: "isFormValid"
                  }
                },
                [
                  _c(
                    "v-container",
                    { attrs: { "grid-list-md": "" } },
                    [
                      _c(
                        "FormFieldsContainer",
                        { attrs: { titulo: "Información General" } },
                        [
                          _c(
                            "v-flex",
                            { attrs: { xs12: "" } },
                            [
                              _c("v-switch", {
                                attrs: {
                                  label: _vm.formFields.activo.label,
                                  color: "success",
                                  "persistent-hint": "",
                                  hint: _vm.mensajeEstado,
                                  readonly: _vm.modoVer
                                },
                                model: {
                                  value: _vm.formFields.activo.value,
                                  callback: function($$v) {
                                    _vm.$set(
                                      _vm.formFields.activo,
                                      "value",
                                      $$v
                                    )
                                  },
                                  expression: "formFields.activo.value"
                                }
                              })
                            ],
                            1
                          ),
                          _c(
                            "v-flex",
                            { attrs: { sm12: "", md12: "" } },
                            [
                              _c("CampoUnico", {
                                directives: [
                                  {
                                    name: "validate",
                                    rawName: "v-validate",
                                    value:
                                      !_vm.modoVer &&
                                      "required|" +
                                        _vm.uniqueFieldRule +
                                        "|max:50",
                                    expression:
                                      "!modoVer && `required|${uniqueFieldRule}|max:50`"
                                  }
                                ],
                                attrs: {
                                  label: _vm.formFields.nombreContrato.label,
                                  "error-messages": _vm.errors.collect(
                                    _vm.formFields.nombreContrato.id
                                  ),
                                  "data-vv-name":
                                    _vm.formFields.nombreContrato.id,
                                  disabled: _vm.modoVer || _vm.modoEditar,
                                  validate: _vm.validarNombre,
                                  message:
                                    "Ya existe un contrato con este nombre",
                                  counter: "50"
                                },
                                model: {
                                  value: _vm.formFields.nombreContrato.value,
                                  callback: function($$v) {
                                    _vm.$set(
                                      _vm.formFields.nombreContrato,
                                      "value",
                                      $$v
                                    )
                                  },
                                  expression: "formFields.nombreContrato.value"
                                }
                              })
                            ],
                            1
                          ),
                          _c(
                            "v-flex",
                            { attrs: { sm12: "", md12: "" } },
                            [
                              _c("v-select", {
                                directives: [
                                  {
                                    name: "validate",
                                    rawName: "v-validate",
                                    value: !_vm.modoVer && "required",
                                    expression: "!modoVer && 'required'"
                                  }
                                ],
                                attrs: {
                                  label: _vm.formFields.proveedorGps.label,
                                  "error-messages": _vm.errors.collect(
                                    _vm.formFields.proveedorGps.id
                                  ),
                                  "data-vv-name":
                                    _vm.formFields.proveedorGps.id,
                                  items: _vm.formFields.proveedorGps.items,
                                  disabled: _vm.modoVer || _vm.modoEditar,
                                  "item-text": "nombre",
                                  "item-value": "id"
                                },
                                model: {
                                  value: _vm.formFields.proveedorGps.value,
                                  callback: function($$v) {
                                    _vm.$set(
                                      _vm.formFields.proveedorGps,
                                      "value",
                                      $$v
                                    )
                                  },
                                  expression: "formFields.proveedorGps.value"
                                }
                              })
                            ],
                            1
                          ),
                          _c(
                            "v-flex",
                            { attrs: { sm12: "", md6: "" } },
                            [
                              _c("v-text-field", {
                                directives: [
                                  {
                                    name: "validate",
                                    rawName: "v-validate",
                                    value:
                                      !_vm.modoVer && "required|min_value:1",
                                    expression:
                                      "!modoVer && 'required|min_value:1'"
                                  }
                                ],
                                attrs: {
                                  label:
                                    _vm.formFields.tiempoMinTransmiciones.label,
                                  "error-messages": _vm.errors.collect(
                                    _vm.formFields.tiempoMinTransmiciones.id
                                  ),
                                  "data-vv-name":
                                    _vm.formFields.tiempoMinTransmiciones.id,
                                  disabled: _vm.modoVer,
                                  type: "number"
                                },
                                model: {
                                  value:
                                    _vm.formFields.tiempoMinTransmiciones.value,
                                  callback: function($$v) {
                                    _vm.$set(
                                      _vm.formFields.tiempoMinTransmiciones,
                                      "value",
                                      $$v
                                    )
                                  },
                                  expression:
                                    "formFields.tiempoMinTransmiciones.value"
                                }
                              })
                            ],
                            1
                          ),
                          _c(
                            "v-flex",
                            { attrs: { sm12: "", md6: "" } },
                            [
                              _c("v-text-field", {
                                directives: [
                                  {
                                    name: "validate",
                                    rawName: "v-validate",
                                    value:
                                      !_vm.modoVer && "required|min_value:1",
                                    expression:
                                      "!modoVer && 'required|min_value:1'"
                                  }
                                ],
                                attrs: {
                                  label:
                                    _vm.formFields.tiempoMaxTransmiciones.label,
                                  "error-messages": _vm.errors.collect(
                                    _vm.formFields.tiempoMaxTransmiciones.id
                                  ),
                                  "data-vv-name":
                                    _vm.formFields.tiempoMaxTransmiciones.id,
                                  disabled: _vm.modoVer,
                                  type: "number"
                                },
                                model: {
                                  value:
                                    _vm.formFields.tiempoMaxTransmiciones.value,
                                  callback: function($$v) {
                                    _vm.$set(
                                      _vm.formFields.tiempoMaxTransmiciones,
                                      "value",
                                      $$v
                                    )
                                  },
                                  expression:
                                    "formFields.tiempoMaxTransmiciones.value"
                                }
                              })
                            ],
                            1
                          ),
                          _c(
                            "v-flex",
                            { attrs: { sm12: "", md6: "" } },
                            [
                              _c("v-text-field", {
                                directives: [
                                  {
                                    name: "validate",
                                    rawName: "v-validate",
                                    value:
                                      !_vm.modoVer && "required|min_value:1",
                                    expression:
                                      "!modoVer && 'required|min_value:1'"
                                  }
                                ],
                                attrs: {
                                  label: _vm.formFields.bloqueEnvio.label,
                                  "error-messages": _vm.errors.collect(
                                    _vm.formFields.bloqueEnvio.id
                                  ),
                                  "data-vv-name": _vm.formFields.bloqueEnvio.id,
                                  disabled: _vm.modoVer,
                                  type: "number"
                                },
                                model: {
                                  value: _vm.formFields.bloqueEnvio.value,
                                  callback: function($$v) {
                                    _vm.$set(
                                      _vm.formFields.bloqueEnvio,
                                      "value",
                                      $$v
                                    )
                                  },
                                  expression: "formFields.bloqueEnvio.value"
                                }
                              })
                            ],
                            1
                          ),
                          _c(
                            "v-flex",
                            { attrs: { sm12: "", md6: "" } },
                            [
                              _c("v-text-field", {
                                directives: [
                                  {
                                    name: "validate",
                                    rawName: "v-validate",
                                    value:
                                      !_vm.modoVer && "required|min_value:1",
                                    expression:
                                      "!modoVer && 'required|min_value:1'"
                                  }
                                ],
                                attrs: {
                                  label:
                                    _vm.formFields.cantidadReintentos.label,
                                  "error-messages": _vm.errors.collect(
                                    _vm.formFields.cantidadReintentos.id
                                  ),
                                  "data-vv-name":
                                    _vm.formFields.cantidadReintentos.id,
                                  disabled: _vm.modoVer,
                                  type: "number"
                                },
                                model: {
                                  value:
                                    _vm.formFields.cantidadReintentos.value,
                                  callback: function($$v) {
                                    _vm.$set(
                                      _vm.formFields.cantidadReintentos,
                                      "value",
                                      $$v
                                    )
                                  },
                                  expression:
                                    "formFields.cantidadReintentos.value"
                                }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _c(
                        "div",
                        { attrs: { align: "left" } },
                        [
                          _c(
                            "h3",
                            [
                              _vm._v(
                                "\n              Endpoint\n              "
                              ),
                              !_vm.modoVer
                                ? _c(
                                    "v-btn",
                                    {
                                      attrs: { flat: "", icon: "", small: "" },
                                      on: {
                                        click: _vm.handleValidarEndpointClick
                                      }
                                    },
                                    [
                                      _c(
                                        "v-icon",
                                        { attrs: { color: "#228B22" } },
                                        [_vm._v("play_arrow")]
                                      )
                                    ],
                                    1
                                  )
                                : _vm._e()
                            ],
                            1
                          ),
                          _c("v-divider"),
                          _c("br")
                        ],
                        1
                      ),
                      _c(
                        "v-layout",
                        { attrs: { wrap: "" } },
                        [
                          _c(
                            "v-flex",
                            { attrs: { md12: "" } },
                            [
                              _c("CodeView", {
                                attrs: { readOnly: _vm.modoVer },
                                on: { blur: _vm.handleEndpointBlur },
                                model: {
                                  value: _vm.formFields.endpoint.value,
                                  callback: function($$v) {
                                    _vm.$set(
                                      _vm.formFields.endpoint,
                                      "value",
                                      $$v
                                    )
                                  },
                                  expression: "formFields.endpoint.value"
                                }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _c("ValidarEndpointModal", {
        attrs: {
          show: _vm.muestraModalValidar,
          script: _vm.formFields.endpoint.value
        },
        on: { blur: _vm.handleEndpointBlur, cerrar: _vm.handleCierreModal }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }